import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import AboutHero from './components/AboutHero';
import BrandStory from './components/BrandStory';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import { aboutData } from '@/mocks/about';

const FORM_URL = 'http://kp51.cn/';

export default function About() {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于我们 - 吃瓜网站线路一',
            description: '吃瓜网站线路一致力于为吃瓜群众提供最新、最快、最全的网红塌房与黑料爆料资讯。了解我们的品牌故事、信誉保障与联系方式。',
            url: 'http://kp51.cn/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '吃瓜网站线路一',
              url: 'http://kp51.cn/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'http://kp51.cn/' },
                { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://kp51.cn/about' },
              ],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: aboutData.faq.items.map((item) => ({
              '@type': 'Question',
              name: item.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
              },
            })),
          }),
        }}
      />
      <Navbar />
      <main>
        <AboutHero />
        <div className="bg-background-50">
          <Breadcrumb items={breadcrumbItems} />
        </div>
        <BrandStory />
        <Reputation />
        <ContactSection contact={aboutData.contact} formUrl={FORM_URL} />
        <TestimonialSection />
        <FAQSection />
        <section className="relative w-full py-16 md:py-20 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20deep%20crimson%20and%20dark%20amber%20flowing%20waves%2C%20luxurious%20dark%20red%20texture%20with%20golden%20highlights%2C%20smooth%20elegant%20color%20transition%2C%20modern%20artistic%20background%2C%20pure%20abstract%2C%20soft%20motion%20blur%2C%20rich%20warm%20tones%2C%20professional%20cinematic%20look&width=1920&height=600&seq=about-cta-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/50"></div>
          <div className="relative z-10 text-center px-4">
            <h2 className="text-2xl md:text-4xl font-bold text-white font-heading mb-4">
              准备好开始吃瓜了吗？
            </h2>
            <p className="text-sm md:text-base text-white/60 mb-8 max-w-md mx-auto">
              每天都有新的大瓜在等着你，快来一起加入吃瓜大军！
            </p>
            <a
              href="/"
              className="inline-flex items-center gap-2 bg-white text-foreground-950 px-8 py-3 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-white/90 transition-all duration-200 hover:scale-105 cursor-pointer"
            >
              立即开始吃瓜
              <span className="w-5 h-5 flex items-center justify-center bg-foreground-950 text-white rounded-full">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}